module.exports = __webpack_public_path__ + "media/src/assets/fonts/Montserrat-SemiBold-cbdf3ab950d15019fff93460614948b7.otf";